module.exports = __webpack_public_path__ + "static/media/SmoothEarl.e9fbe457.jpg";